<template>
  <div class="sign_up">
    <div id="head-page" class="inscription parallaxe">
      <parallax>
        <div id="bg1" data-depth="0.15"><img class="" src="@/assets/images/head/montagnes-02.png" alt="" title="" /></div>
        <div id="bg2" data-depth="0.2"><img class="" src="@/assets/images/head/sapins-big.png" alt="" title="" /></div>
        <div id="bg3" data-depth="0.1"><img class="" src="@/assets/images/head/sapins-small.png" alt="" title="" /></div>
        <div id="front-1" data-depth="0.2"></div>
      </parallax>
    </div>

    <div class="box-double hal white">
      <div class="box-mascotte">
        <img src="@/assets/images/mascotte/mascotte-blind.png" alt="Globulo Quest mascotte" title="Globulo Quest mascotte"/>
        <div class="box-eye">
          <div class="eye"></div>
       </div>

        <div class="bubble right txtleft" :class="{off: !bubble}">Bonjour, je suis Globulo ! Je suis là pour vous guider dans l’utilisation de cette plateforme et vous tenir compagnie. Et si on commençait par se créer un compte Globulo Quest ? <i class="bt_close fas fa-times-circle" @click="closeBubble"></i></div>
      </div>
    </div>

    <div class="grid-container content-page inscription">
      <div class="grid-x grid-margin-x">
        <div class="small-12 medium-8 medium-offset-2 large-6 large-offset-3 cell">

          <h3 class="center">Inscrivez-vous :</h3>
          <div class="formulaire inscription nobot">
            <form ref="form">
              <div class="content">

                <div class="box-form">

                  <p class="infos"><i class="fas fa-info-circle"></i>Ce formulaire permet de créer un compte soignant afin de pouvoir accompagner les enfants tout au long de leur parcours de soins.</p>

                  <div class="line" :class="{'error': errors.indexOf('gender') !== -1}">
                    <label for="genre-m"><br> Qui êtes vous ?</label>
                    <div class="box-radio"><input type="radio" id="genre-m" name="gender" value="H" v-model="gender" ><label for="genre-m">Un homme</label></div>
                    <div class="box-radio"><input type="radio" id="genre-f" name="gender" value="F" v-model="gender" ><label for="genre-f">Une femme</label></div>
                  </div>
                  </br>

                  <!-- TODO Je ne sais pas si cette liste te suffit pour le choix du métier -->
                  <div :class="{error: errors.indexOf('job') !== -1}">
                    <label for="job">Profession :</label>
                    <select name="job" id="job" v-model="job" required >
                      <option v-for="job,job_id of SoignantDB" :value="job_id" :key="job_id">{{ job.name }}</option>
                    </select>
                  </div>

                  <div :class="{error: errors.indexOf('firstname') !== -1}">
                    <label for="prenom">Quel est votre prénom ?</label>
                    <input type="text" name="first_name" id="prenom" v-model="first_name" required />
                  </div>

                  <div :class="{error: errors.indexOf('lastname') !== -1}">
                    <label for="nom">Quel est votre nom ?</label>
                    <input type="text" name="last_name" id="nom" v-model="last_name" required />
                  </div>

                  <div :class="{error: errors.indexOf('email') !== -1}">
                    <label for="email">Quel est votre email ?</label>
                    <input type="email" name="email" id="email" v-model="email" required />
                  </div>

                  <div :class="{'error password': errors.indexOf('password') !== -1}">
                    <label for="password">Tapez votre mot de passe :</label>
                    <input type="password" name="password" id="password" v-model="password" required />
                  </div>

                  <div :class="{error: errors.indexOf('password') !== -1, password: errors.indexOf('password') !== -1}">
                    <label for="password-confirm">Confirmez votre mot de passe :</label>
                    <input type="password" name="password_confirmation" id="password-confirm" v-model="password_confirmation" required />
                  </div>

                  <div :class="{'error': errors.indexOf('cgu') !== -1}" cf-questions="J'ai lu et j'accepte <a href='cgu' target='_blank'>les conditions générales d'utilisation.</a>">
                    <input required type="checkbox" id="scales" name="feature" value="scales" v-model="cgu"/>
                    <label for="scales" class="cgu">J'ai lu et j'accepte <a href="cgu" title="conditions générales d'utilisation" target="blank">les conditions générales d'utilisation</a></label>
                  </div>
                  </br>
                  </br>
                  <input class="button btnPush" name="submit" type="submit" value="Valider mon inscription" @click="send" @mouseover="verify" />
                  </br>
                  </br>
                  <p><em>* Champs obligatoires</em></p>
                  <p><em>Pensez à vérifier vos spams une fois l'inscription validée afin de recevoir le mail de confirmation.</em></p>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapActions } from 'vuex'
  import conversationalForm from 'conversational-form'
  import SoignantDB from '@/datas/soignants.json'

  export default {
    data () {
      return {
        gender: '',
        job: '',
        first_name: '',
        last_name: '',
        email: '',
        password: '',
        password_confirmation: '',
        cgu: false,
        bubble: true,
        errors: [],
        SoignantDB
      }
    },
    methods: {
      ...mapActions([ 'signup', 'signout']),
      closeBubble () {
        this.bubble = false;
      },
      verify (field) {
        this.errors = []
        if (!this.password || this.password !== this.password_confirmation) {
          this.errors.push("password")
        }
        if (!this.job) {
          this.errors.push("job")
        }
        if (!this.first_name) {
          this.errors.push("firstname")
        }
        if (!this.last_name) {
          this.errors.push("lastname")
        }
        if (!this.email) {
          this.errors.push("email")
        }
        if (!this.gender) {
          this.errors.push("gender")
        }
        if (!this.cgu) {
          this.errors.push("cgu")
        }
      },
      async send (e) {
        e.preventDefault();
        this.verify();
        if (this.errors.length > 0) {
          return false
        }

        try {
          await this.signup({
            email: this.email,
            password: this.password,
            title: this.job,
            account_type: 'caregiver',
            first_name: this.first_name,
            last_name: this.last_name,
            gender: this.gender
          });
          this.$router.push({name: 'PostSignUpCaregiver'})
        } catch (ex) {
          console.log('error', ex);
        }
      }
    }
  }
</script>
